export default "__VITE_ASSET__D4fPBW1v__"